/** @type {Record<string, import('../entities/ReconciliationTask.types').ReconciliationTaskStatus>} */
export const TASK_STATUSES = { // eslint-disable-line import/prefer-default-export
  PENDING: 'pending',
  PROCESSING: 'processing',
  LOADED: 'loaded',
  NO_MATCH: 'no_match',
  ALREADY_LINKED: 'already_linked',
  CONFIRMED: 'confirmed',
  LINKED: 'linked',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};
